module.exports = __webpack_public_path__ + "img/telecom.89edaee9.svg";